import { axiosInstance } from "./axios";

export const getCardPrompt = async (card_id: string) => {
    try {
        return await axiosInstance.get(`/event/card-prompt/${card_id}`);
    } catch (error) {
        throw error;
    }
}